import React from 'react';
import { Box } from '@mui/material';
import Header from '../../Principal/containers/Header';
import GestionVendedoresVehiculos from '../containers/GestionVendedoresVehiculos';

export default function AdminDashboardUI({
    onLogout,
    onSwitchProfile,
    onBackToMenu,
}) {
    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <Header
                onLogout={onLogout}
                onSwitchProfile={onSwitchProfile}
                moduleName="ADMINISTRACIÓN"
                disableNotifications={true}
                onBackToMenu={onBackToMenu}
                hideUserInfoInMenu = {true}
            />
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: { xs: 3, md: 7 },
                    px: { xs: 2, md: 4 },
                    py: { xs: 3, md: 4 },
                    overflowY: 'auto',
                }}
            >
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <GestionVendedoresVehiculos />
                </Box>
            </Box>
        </Box>
    );
}
